import VideoPlayer from './VideoPlayer';

export { type VideoPlayerHandle, type VideoPlayerProps } from './VideoPlayer';
export default VideoPlayer;
